import { Component, Host, Prop, Watch, h } from '@stencil/core';
import type { AssortmentTeaser } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-assortment-teaser',
  styleUrl: 'cms-assortment-teaser.scss',
  shadow: true,
})
export class CmsAssortmentTeaser {
  private teaserData: AssortmentTeaser[];

  /**
   * set the element headline
   */
  @Prop() assortmentHeadline: string;

  /**
   * set the assortment overview target ulr
   */
  @Prop() overviewUrl: string;

  /**
   * set the teasers data image, alt, name
   */
  @Prop() teasers: string;

  @Watch('teasers')
  private teasersWatcher(newValue: AssortmentTeaser | string) {
    if (newValue) {
      this.teaserData =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }

  private renderTeaserItem(teaser: AssortmentTeaser) {
    const { name, titleText, url, image } = teaser;
    return (
      <div key={name} class={'assortment-teaser'}>
        <div class={'image-container'}>
          <a href={url} title={name} target='_self'>
            <img
              title={titleText}
              width={image.width}
              height={image.height}
              loading='lazy'
              src={image.url}
              alt={image.alt}
              class={'teaser-image'}
            />
          </a>
        </div>
        <div class={'cta-wrapper'}>
          <cms-link
            class='assortment-cta'
            href={url}
            type='standalone-inverted'
            linkTitle={name}
            content={name}
            size='lg'
            spacing='none'
            rel='noopener'
            target='_self'
            style={{
              '--cms-text-color': 'var(--cms-semanticColors-base-strong-text)',
            }}
          />
        </div>
      </div>
    );
  }

  connectedCallback() {
    if (!this.teasers) {
      return;
    }
    this.teasersWatcher(this.teasers);
  }

  render() {
    return (
      <Host>
        <div class={'assortment-inner'}>
          <div class={'headline-wrapper'}>
            <cms-headline
              headlineText={this.assortmentHeadline}
              headlineTag='h2'
              headlineClass='assortment-headline'
              headlinePosition='center'
              layout='full'
              isAdaptive
            />
          </div>
          <div class={'assortment-teaser-container'}>
            {this.teaserData?.map((teaser) => this.renderTeaserItem(teaser))}
          </div>
        </div>
      </Host>
    );
  }
}
